import React from 'react'

const Services = () => {
  return(
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: "url('assets/img/bg/footer_bg_2.jpg')" }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Our Services</h1>
            <ul className="breadcumb-menu">
              <li><a href="/">Home</a></li>
              <li>Our Services</li>
            </ul>
          </div>
        </div>
      </div>
      <section className="service-area overflow-hidden space" id="service-sec">
        <div className="container">
          <div className="row">
            <div className="title-area mb-0 text-center"><span className="sub-title">Our Services</span>
              <h2 className="sec-title">The Best Service For You</h2>
            </div>
          </div>
          <div className="tab-content" id="nav-tabContent" style={{ marginTop: "40px" }}>
            <div className="tab-pane fade active show" id="nav-step1" role="tabpanel">
              <div className="row gy-4">
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/constructor-with-hard-hat-and-stop-hexagonal-signal-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">01</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Occupational Health & Safety Management Systems</a></h3>
                    <p className="service-box_text">We develop ISO 45001-aligned systems to improve workplace safety, legal compliance, and risk control.</p><a className="line-btn" href="/service-details">Read More
                      <i className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/training-class-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">02</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">SHEQ Training</a></h3>
                    <p className="service-box_text">We provide training on Safety, Health, Environment, and Quality topics to ensure compliance and best practice.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/construction-hazard-banner-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">03</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Construction Health & Safety Files</a></h3>
                    <p className="service-box_text">We compile fully compliant safety files for construction projects, including risk assessments, legal appointments, and safety plans.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/get-ahead-of-risk-and-compliance-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">04</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Risk Management Systems</a></h3>
                    <p className="service-box_text">We help identify and manage business and operational risks through tailored, proactive risk control systems.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/sustainable-sustainability-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">05</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Environmental Management Systems</a></h3>
                    <p className="service-box_text">We implement ISO 14001 systems to help reduce environmental impact and improve sustainability performance.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/shield-attention-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">06</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Awareness Programmes</a></h3>
                    <p className="service-box_text">We run engaging awareness campaigns on SHEQ topics to build a strong culture of safety and responsibility.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/quality-certificate-award-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">07</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Quality Management Systems</a></h3>
                    <p className="service-box_text">We assist with ISO 9001 implementation to enhance product/service quality, consistency, and customer satisfaction.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/workplace-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">08</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">Workplace Skills Plans (WSP)</a></h3>
                    <p className="service-box_text">We develop and submit WSPs and ATRs, helping businesses close skills gaps and access SETA training grants.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
                <div className="col-xl-4 col-md-6">
                  <div className="service-box style2" data-bg-src="assets/img/bg/shape_bg_1.png">
                    <div className="service-content">
                      <div className="service-box_icon"><img src="assets/img/icon/automation-svgrepo-com.svg" alt="icon"/></div>
                      <div className="service-box_number">09</div>
                    </div>
                    <h3 className="box-title"><a href="/service-details">ISO/TS 16949:2009 (Automotive Quality)</a></h3>
                    <p className="service-box_text">We support automotive suppliers with ISO/ TS 16949 systems, focusing on defect prevention and supply chain quality.</p><a className="line-btn" href="/service-details">Read More <i
                        className="fas fa-arrow-right ms-2"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;